module.exports = __webpack_public_path__ + "img/57a944d.jpg";